import { render, staticRenderFns } from "./OrderCreatorServiceEmbroideryConfig.vue?vue&type=template&id=c1b92802&"
import script from "./OrderCreatorServiceEmbroideryConfig.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceEmbroideryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports